import FormError from "./FormError";

interface FormInputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  type?:
    | "text"
    | "email"
    | "password"
    | "number"
    | "tel"
    | "url"
    | "time"
    | "date";
  min?: string | number;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  error?: string;
  errorParams?: Record<string, string | number>;
}

export default function FormInput({
  label,
  value,
  onChange,
  onBlur,
  type = "text",
  min,
  placeholder,
  className = "",
  disabled = false,
  readOnly = false,
  required = false,
  error,
  errorParams,
}: FormInputProps) {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-black mb-2">
          {label}
          {required && <span className="text-black ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type={type}
          min={min}
          value={value}
          onChange={e => onChange(e.target.value)}
          onBlur={readOnly ? undefined : onBlur}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          className={`
            w-full py-2 text-sm
            focus:outline-none transition-colors duration-200
            ${
              readOnly
                ? "px-3 bg-gray-100 border border-gray-300 rounded-md text-gray-500 focus:ring-0 focus:outline-none focus:border-gray-300 cursor-not-allowed"
                : error
                  ? "px-3 bg-white border border-red-500 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 cursor-text"
                  : "px-3 bg-white border border-gray-300 rounded-md hover:border-gray-400 focus:ring-2 focus:ring-primary focus:border-primary cursor-text"
            }
            ${disabled ? "opacity-50 cursor-not-allowed bg-gray-50" : ""}
          `}
        />
      </div>
      <FormError error={error} params={errorParams} />
    </div>
  );
}
